import Vue from "vue";

const getCalendarData = () =>
  Vue.prototype.$http.get("calendar/").then((response) => {
    return response.data;
  });

export { getCalendarData };
